// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Alcohol_wrapper__8JMvF","btn":"Alcohol_btn__yE5tT","container":"Alcohol_container__eLufx"};